<template>
  <div class="page-container">
    <a-page-header class="page-header" @back="back">
      <div slot="title" style="cursor: pointer" @click="back">
        返回
        <span class="header-title">{{ stuInitInfo.pageName || '' }}</span>
      </div>
    </a-page-header>
    <div>
      <PersonalDetails
        :basicInfoProp="basicInfo"
        :loading="loading"
        :beginDate="beginDate"
        :endDate="endDate"
        @search="(data) => refreshArchives(data, 1)"
      />
      <MoodArchives ref="moodArchives" :stuInitInfo="stuInitInfo" />
      <StuCareArchivesRecord
        :timeline="timeline"
        :loading="careLoading"
        :stuInitInfo="stuInitInfo"
        :beginDate="beginDate"
        :endDate="endDate"
        @refreshData="(data) => refreshArchives(data, 2)"
      />
    </div>
    <!--    <template v-if="!Object.keys(basicInfo).length">-->
    <!--      <EmptyData :loading="loading" :isSetPageCenter="true" />-->
    <!--    </template>-->
  </div>
</template>

<script>
import PersonalDetails from './components/PersonalDetails'
import MoodArchives from './components/MoodArchives'
import StuCareArchivesRecord from './components/StuCareArchivesRecord'
import { getAction } from '@api/manage'
import moment from 'moment'
import { getDictCodeData, getYearStarting } from '@/utils/util'

export default {
  name: 'ArchivesViewPage',
  components: {
    PersonalDetails,
    MoodArchives,
    StuCareArchivesRecord,
  },
  data() {
    return {
      beginDate: moment().subtract(14, 'days').format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
      stuInitInfo: {},
      basicInfo: {},
      chartObj: {},
      timeline: [],
      queryParam: {},
      loading: false,
      careLoading: false,
    }
  },
  created() {
    const studentInfo = this.$router.history?.current?.query || {}
    this.stuInitInfo = { ...studentInfo, beginDate: this.beginDate, endDate: this.endDate }
    this.getArchivesData()
    // 获取关爱学生档案
    this.getStuCareArchivesData()
  },
  methods: {
    async getArchivesData() {
      this.loading = true
      const params = {
        id: this.stuInitInfo.studentId,
        beginDate: this.beginDate,
        endDate: this.endDate,
        ...this.queryParam,
      }
      const res = await getAction('/aigoes/studentInfo/studentProfile', params)
      this.loading = false
      if (res.success) {
        this.basicInfo = res.result
      }
    },
    // 获取关爱学生档案
    async getStuCareArchivesData() {
      this.loading = true
      const params = {
        id: this.stuInitInfo.studentId,
        beginDate: this.beginDate,
        endDate: this.endDate,
        ...this.queryParam,
      }
      this.careLoading = true
      const res = await getAction('/aigoes/studentInfo/studentCareRecord', params)
      this.careLoading = false
      if (res.success) {
        this.timeline = res.result.timeline || []
      }
    },
    resetData() {
      this.basicInfo = {}
      this.chartObj = {}
      this.timeline = []
    },
    back() {
      this.resetData()
      // pagePath是记录着的上一个路径，打开新标签页时需要带上
      if (this.stuInitInfo?.pagePath) {
        console.log('pagePath--', this.stuInitInfo.pagePath)
        this.$router.push({
          path: this.stuInitInfo.pagePath,
          query: this.stuInitInfo.tab && { tab: this.stuInitInfo.tab },
        })
        return
      }
      this.$router.go(-1)
    },
    // 刷新
    refreshArchives(data, type) {
      console.log('data--', data)
      // type: 1 为学生个人信息筛选，2 学生关爱档案记录筛选
      if (!data) {
        this.$set(this.queryParam, 'recordTypes', undefined)
      }
      if (data && data.beginDate) this.beginDate = data.beginDate
      if (data && data.endDate) this.endDate = data.endDate
      this.queryParam =  { ...this.queryParam, ...(data || {}) } 
      // 学期或时间变化时，刷新曲线图
      if (type == 1) {
        this.getArchivesData()
        this.stuInitInfo = { ...this.stuInitInfo, ...(data || {})  }
        this.getStuCareArchivesData()
      } else if (type == 2) {
        this.getStuCareArchivesData()
      }
    },
  },
}
</script>
<style scoped lang="less">
.page-header {
  padding: 0;
  /deep/ .ant-page-header-heading-title {
    font-size: 14px;
  }
  .header-title {
    color: #297ede;
  }
}
</style>
